import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { CookiesService } from '../cookies/cookies.service';
import { AdminService } from '../admin/admin.service';
import { FormatErrors, FormatTitleErrors } from '@pkg-framework/forms/controls/FormControl';
import { NotifyModalService } from '@pkg-services/notification/NotifyModal.service';
import { Router } from '@angular/router';

function isI18nTranslateRequest(url: string): boolean {
  return url.includes('/i18n/translate');
}

function isTranslationServiceError(err: any): boolean {
  const code = String(err?.error?.code ?? '');
  return code === 'translation_unavailable' || code === 'translation_busy';
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const Cookies = inject(CookiesService);
  const adminService = inject(AdminService);
  const notification = inject(NotifyModalService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: any) => {
      const url = String(req?.url || '');

      // Traduction MarianMT : message géré par le FormGenerator (pas de toast technique).
      if (isI18nTranslateRequest(url) || isTranslationServiceError(err)) {
        return throwError(() => err);
      }

      if (err.status === 401) {
        adminService.clearCurrentAdmin();
        Cookies.remove();
        const errorMessages = FormatErrors(err);
        const fallbackMessage = ['Votre session a expiré. Veuillez vous reconnecter.'];
        notification.error('Session expirée', errorMessages.length > 0 ? errorMessages : fallbackMessage);
        router.navigate(['/login']).then();
        return throwError(() => err);
      } else if (err.status === 403) {
        const errorMessages = FormatErrors(err);
        const fallbackMessage = ["Vous n'avez pas les permissions nécessaires."];
        notification.error('Accès refusé', errorMessages.length > 0 ? errorMessages : fallbackMessage);
        return throwError(() => err);
      } else if (err.status === 422 || err.status === 409) {
        const errorMessages = FormatErrors(err);
        const fallbackMessage = ['Les données saisies ne sont pas valides.'];
        notification.error('Données invalides', errorMessages.length > 0 ? errorMessages : fallbackMessage);
        return throwError(() => err);
      } else {
        const errorMessages = FormatErrors(err);
        const fallbackMessage = ["Une erreur inattendue s'est produite."];
        const errorTitle = FormatTitleErrors(err);
        notification.error(errorTitle, errorMessages.length > 0 ? errorMessages : fallbackMessage);
        return throwError(() => err);
      }
    })
  );
}
